export default __webpack_public_path__ + "static/calendar-icon-13286debadc196742124fa760410e6c6.png";